module.exports = __webpack_public_path__ + "static/media/food6.5421929a.JPG";